export default __webpack_public_path__ + "static/applet-12-set-2-ea13d71e96a1ad747451eb85f14e9738.webp";